import { ref } from "vue";

export const goToWait = ref(false)
